import { useEffect, useState } from 'react';
import RequestItem from './RequestItem';
import { ClubAPI } from '../../../api/ClubAPI';
import { useSelector } from 'react-redux';
import Loader from '../../../component/Loader';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI';
import { Privileges } from '../../../util/PrivilegeConstants';

const JoinRequest = () => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [privileges, setPrivileges] = useState({});
  const fetchAllJoinRequests = async () => {
    try {
      setIsLoading(true);
      const response = await ClubAPI.fetchAllJoinRequests(selectedClub.clubId);
      setRequests(response.Data);
    } catch (error) {

    } finally {
      setIsLoading(false);
    }
  }

  const findAllPrivileges = async () => {
    try {
      setIsLoading(true)
      const reqObj = {
        userId: userInfo.userId,
        featureName: Object.keys(Privileges)[14]
      }
      const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
      setPrivileges(response.Data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (userInfo.userId) {
      findAllPrivileges();
    }
  }, [userInfo.userId]);

  useEffect(() => {
    if (selectedClub.clubId) {
      fetchAllJoinRequests();
    }
    refresh && setRefresh(true)
  }, [refresh, selectedClub.clubId])


  return (
    <div className='sm_join_request_container'>
      {isLoading && <Loader />}
      <h1>Join Requests</h1>
      {requests?.length != 0 ?
      <div className='sm_join_request_list'>
        {
          requests?.map((request, index) =>
            <RequestItem
              key={index}
              request={request}
              setIsLoading={setIsLoading}
              clubId={selectedClub?.clubId}
              setRefresh={setRefresh}
              privileges={privileges}
            />
          )
        }
      </div>
      :
        <div className='sm_join_request_not_found'>
          <p>There are currently no join requests. New requests will show up here as soon as someone applies to join your club.</p>
      </div>}
    </div>
  )
}

export default JoinRequest;